import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import Select from "react-select"
import ClientPortalEmployeeAccessLevelAreaTypes from "../Types/ClientPortalEmployeeAccessLevelAreaTypes"
import ServiceAreaTypes from "../Types/ServiceAreaTypes"
import EALAService from "../Utils/EALAService"
import mutator from "src/utilities/mutator"
import serviceAreaBoiler from "../Utils/BoilerPlates/serviceAreaBoiler"
import "./EALAAddServiceArea.css"

interface Props {
    manageParentState: Function
    callParentFunction: Function
    eala: ClientPortalEmployeeAccessLevelAreaTypes
}

interface State {
    selectedServiceArea: ServiceAreaTypes
}

class EALAAddServiceArea extends Component<Props, State> {

    state = {
        selectedServiceArea: { ...serviceAreaBoiler }
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: { key: string, value?: any }[]) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    render() {

        const { manageParentState, callParentFunction, eala } = this.props
        const { selectedServiceArea } = this.state
        const { lookupHashTableItem, getAvailableAreasScopedByProfitCenterID } = EALAService
        const availableAreas = getAvailableAreasScopedByProfitCenterID(40, eala.ProfitCenterID, true)
        const bucketItem = lookupHashTableItem("serviceAreaTable", eala.ServiceAreaID)
        const canSave = selectedServiceArea.ServiceAreaID > -1 && (selectedServiceArea.ServiceAreaID !== eala.ServiceAreaID)
        const currentDefaultServiceArea = bucketItem ? bucketItem[1] : serviceAreaBoiler

        // console.log("EALAAddServiceArea props", this.props)
        // console.log("EALAAddServiceArea state", this.state)
        // console.log("EALAAddServiceArea bucketItem", bucketItem)

        return (
            <div className="EALAAddServiceArea">
                <Modal
                    id="add-service-area-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="sm"
                >
                    <Modal.Header>
                        <div className="EALAAddServiceAreaModalHeader">
                            <span id={eala.ServiceAreaID ? "f13f4c8668884a84ada05c809dff0d372" : "cdf23f179f3e450c9d64c367ab84be9f2"} className="material-icons">{`${eala.ServiceAreaID ? "edit" : "add"}`}</span>
                            <p>{`${eala.ServiceAreaID ? "Edit the added service area" : "Add a service area"}`}</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="EALAAddServiceAreaModalBody">
                            <Select
                                placeholder={"End user"}
                                value={{ label: !canSave ? currentDefaultServiceArea.ServiceAreaLongDesc : selectedServiceArea.ServiceAreaLongDesc }}
                                options={availableAreas.map((area) => ({ value: area.id, label: area.text }))}
                                onChange={(item: { label: string, value: number }) => {
                                    const serviceAreaId = item.value
                                    const bucketItem = lookupHashTableItem("serviceAreaTable", serviceAreaId)
                                    if (bucketItem) {
                                        this.manageState([{ key: "selectedServiceArea", value: bucketItem[1] }])
                                    }
                                }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="EALAAddServiceAreaModalFooter">
                            <Button variant="secondary" onClick={() => manageParentState([{ key: "ealaToAddServiceAreaTo", value: null }])}>Cancel</Button>
                            <Button variant="primary" disabled={!canSave} onClick={() => {
                                const newArea = { ...eala, ...{ ServiceAreaID: selectedServiceArea.ServiceAreaID } }
                                callParentFunction("editEALAS", [newArea], "EALAAddServiceAreaBusy", true)
                                manageParentState([{ key: "ealaToAddServiceAreaTo", value: -1 }])
                            }}>Save</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default EALAAddServiceArea